import React, { useEffect } from "react";
import HomeAbout from "../Component/HomePage/HomeAbout";
import HomeBanner from "../Component/HomePage/HomeBanner";
import HomeRoom from "../Component/HomePage/HomeRoom";
import HomeCommitment from "../Component/HomePage/HomeCommitment";
import HomeOffer from "../Component/HomePage/HomeOffer";
import HomeMap from "../Component/HomePage/HomeMap";
import HomeFacilites from "../Component/HomePage/HomeFacilities";
import Footer from "../Component/Footer/Footer";
import { MetaTags } from "react-meta-tags";
import HomeTestimonial from "../Component/HomePage/HomeTestimonial";
import Homegallery from "../Component/HomePage/Homegallery";
const HomePage = (()=>{
    useEffect(()=>{
        window.scrollTo(0, 0);
    },[])
    return(
        <>
        <MetaTags>
                <title>Resort In Neral | Seema Resort</title>
                <meta title="Resort In Neral | Seema Resort" />
                <meta name="description" content="Experience tranquility at Seema Resort in Neral, offering luxurious stays, scenic views, and modern amenities for a perfect getaway." />
                <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
                <link rel="canonical" href="https://seemasresort.com" />
                <meta http-equiv="cache-control" content="no-cache" />
                <meta http-equiv="expires" content="0" />
                <meta http-equiv="pragma" content="no-cache" />
                <meta property="og:title" content=" Resort In Neral | Seema Resort" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://seemasresort.com/" />
                <meta property="og:description" content="Experience tranquility at Seema Resort in Neral, offering luxurious stays, scenic views, and modern amenities for a perfect getaway." />
                <meta property="og:image" content="https://seemasresort.com/static/media/logo.png" />
              </MetaTags>
        <HomeBanner/>
        <HomeAbout/>
        <HomeRoom/>
        {/* <HomeOffer/> */}
        <HomeFacilites/>
        <HomeCommitment/>
        <Homegallery/>
        <HomeTestimonial/>
        <HomeMap/>
        <Footer/>
        </>
    )
});
export default HomePage;